import { useEffect, useState } from "react";
import DevTable from "@shared/Table/Dev/Table";
import { recent_requests_data } from "@utils/constants";
import {
  AgentRequestAction,
  completedInspection,
  getAgentRequest,
  getComments,
} from "@services/krentDeveloper";
import { Modal } from "react-bootstrap";
import UploadReceipt from "components/UsersDashboard/uploadReceipt";
import { toast } from "react-toastify";
import { formatDateToTime } from "@utils/helpers";
import { useNavigate } from "react-router-dom";

interface Request {
  propertyID: any;
  requestDate: string;
  interestID: string;
  propertyName: string;
  status: string;
  clientName: string;
}
const steps = [
  "Request accepted",
  "Inspection confirmed",
  "Payment made",
  "Documentation process",
  "Documentation received",
];

export const DeveloperRequests = () => {
  // const [transactions, setTransactions] = useState<any[]>([]);

  const [requests, setRequests] = useState<any | null>(null);

  const [pendingModal, setPendingModal] = useState(false);
  const [acceptedModal, setAcceptedModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showProceedtoUploadDoc, setShowProceedtoUploadDoc] = useState(false);
  const [isAgentUpload, setIsAgentUpload] = useState(false);
  const [purchaseUpdate, setPurchaseUpdate] = useState(false);
  const [questionModal, setQuestionModal] = useState(false);
  const [devComments, setDevComments] = useState([]);
  const navigate = useNavigate();

  const refetchRequests = () => {
    const abortController = new AbortController();

    getAgentRequest(abortController.signal)
      .then((res) => {
        setRequests(res);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to refresh requests.");
      });
  };
  useEffect(() => {
    const abortController = new AbortController();

    getAgentRequest(abortController.signal)
      .then((res) => {
        setRequests(res);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.log(err);
        }
      });

    return () => {
      abortController.abort();
    };
  }, []);

  const handleAction = (action: string) => {
    setIsLoading(true);
    const abortController = new AbortController();

    if (selectedRequest) {
      AgentRequestAction(
        action,
        selectedRequest.interestID,
        abortController.signal
      )
        .then((res) => {
          toast.success(res.message || `Request ${action}ed successfully`);
          console.log(res);

          setRequests((prevRequests: { data: any[]; }) =>
            prevRequests
              ? {
                ...prevRequests,
                data: prevRequests.data.map((req) =>
                  req.id === selectedRequest.interestID
                    ? {
                      ...req,
                      status: action === "accept" ? "Accepted" : "Rejected",
                    }
                    : req
                ),
              }
              : prevRequests
          );

          // setTransactions((prevTransactions) =>
          //   prevTransactions.map((transaction) =>
          //     transaction.id === selectedRequest.interestID
          //       ? {
          //         ...transaction,
          //         status: action === "accept" ? "Accepted" : "Rejected",
          //       }
          //       : transaction
          //   )
          // );

          setPendingModal(false);

          refetchRequests();
        })
        .catch((err) => {
          toast.error(`Failed to ${action} request: ${err?.message || err}`);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    return () => {
      abortController.abort();
    };
  };
  const handleInspectionCompleted = async () => {
    if (!selectedRequest) return {};
    setIsLoading(true);
    try {
      const abortController = new AbortController();
      const res = await completedInspection(
        selectedRequest.interestID,
        abortController.signal
      );
      toast.success(res.message);
      setTimeout(() => {
        setQuestionModal(false);
      }, 2000);
    } catch (err) {
      console.error("Error completing inspection:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchComments = async (itemId: string) => {
    const abortController = new AbortController();
    try {
      const response = await getComments(itemId, abortController.signal);
      setDevComments(response.data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    if (selectedRequest?.interestID) {
      fetchComments(selectedRequest.interestID);
    }

    // if (item?._id) {
    //   fetchClientDocument(item._id)
    // }
  }, [selectedRequest]);

  const renderStatusCell = (cell: any) => {
    if (cell.column.id === "action") {
      const status = cell.row.original.status;
      const isRejected = status === "Rejected";

      const handleActionButtonClick = (e: any) => {
        e.preventDefault();
        setSelectedRequest(cell.row.original);

        const pendingStatuses = ["Interest", "Pending"];
        const acceptedStatuses = [
          "Accepted",
          "Inspection Booked",
          "Inspection Completed",
        ];

        if (pendingStatuses.includes(status)) {
          setPendingModal(true);
        } else if (acceptedStatuses.includes(status)) {
          setAcceptedModal(true);
        } else if (status === "Purchase-Request") {
          setIsAgentUpload(true);
          setShowProceedtoUploadDoc(true);
        }
      };

      return (
        <div className="flex items-center justify-between">
          <button
            className={`rounded-10 p-2 border-green text-primary fw-bold border-green bg-white ${isRejected ? "opacity-50 light-text cursor-not-allowed" : ""
              }`}
            onClick={handleActionButtonClick}
            disabled={isRejected}
          >
            View details
          </button>
        </div>
      );
    }
    if (cell.column.id === "status") {
      const isCompleted = cell.value === "Accepted" || cell.value === "Sold";
      const isRejected = cell.value === "Rejected";

      return (
        <div className="flex items-center justify-between">
          <span
            className={`rounded-10 p-2 ${isRejected ? "previous " : isCompleted ? "current " : "future "
              } `}
          >
            {cell.value === "Interest" ||
              cell.value === "Purchase-request" ||
              cell.value === "Pending"
              ? "Pending"
              : cell.value}
          </span>
        </div>
      );
    }
    if (cell.column.id === "details") {
      return (
        <div className="flex items-center justify-between">
          <button
            className="text-black border rounded-10 bg-white flex items-center"
            onClick={() => {
              setSelectedRequest(cell.row.original);
              setPurchaseUpdate(true);
            }}
          >
            <span>View purchase update</span>&nbsp;
            <i className="fa fa-arrow-up-right mr-2" />
          </button>
        </div>
      );
    }
    return cell.render("Cell");
  };
  const getCurrentStep = (selectedRequest: any) => {
    console.log(selectedRequest, "Selected");

    if (selectedRequest?.status === "Pending" || !selectedRequest?.status)
      return 0;

    if (
      selectedRequest.status === "Accepted" ||
      selectedRequest.status === "Inspection Booked"
    )
      return 1;

    if (selectedRequest.status === "Inspection Completed")
      return 2;

    if (
      selectedRequest.status === "confirmed" ||
      selectedRequest.status === "Purchase-Request"
    )
      return 3;

    if (selectedRequest.status === "Documentation process")
      return 4;

    if (
      selectedRequest.status === "Sold" ||
      (selectedRequest.purchaseDocument && Object.keys(selectedRequest.purchaseDocument).length > 0)
    )
      return 5;

    return 0;
  };

  return (
    <div>
      <div className="mt-4">
        <div className="mb-3">
          <h5 className="py-2">Developer Project Requests</h5>
          <p className="text-secondary fs-14">
            Manage all developer property requests on your property
          </p>
        </div>
        <DevTable
          columnData={recent_requests_data}
          rowData={requests}
          label="sold properties"
          totalDocs={requests?.length}
          renderCell={renderStatusCell}
        />
        <Modal show={pendingModal} onHide={() => setPendingModal(false)}>
          <div className="container p-4">
            <p className="fw-bold ">Someone has made a request for an agent</p>
            <p className="py-2">
              You have been selected to be an agent for this property: Which
              means an interest has been made for the property
            </p>
            <p>Please take prompt action by accepting or rejecting</p>
            <div className="w-full flex justify-between my-4 gap-4">
              <button
                onClick={() => handleAction("accept")}
                className="btn btn-primary rounded-pill py-2 text-white fw-bold w-full"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Accept"}
              </button>
              <button
                onClick={() => handleAction("reject")}
                className="btn border-red text-red bg-white rounded-pill py-2 fw-bold w-full"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Reject"}
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          show={purchaseUpdate}
          onHide={() => setPurchaseUpdate(false)}
          size="lg"
        >
          <div className="container p-4">
            <div className="flex justify-between items-center">
              <p className="fw-bold ">Purchase update</p>
              <button
                className="fw-bold bg-white"
                onClick={() => setPurchaseUpdate(false)}
              >
                X
              </button>
            </div>
            <hr />
            <div className="my-2">
              {
                selectedRequest &&
                <a className="text-primary fw-600" href={`developer-project-property/${selectedRequest?.propertyID}`}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/developer-project-property/${selectedRequest?.propertyID}`, {
                      state: { fromAgentPage: true },
                    });
                  }}
                >View property</a>

              }
            </div>
            <div>
              <div
                className="stepper-container"
                style={
                  {
                    "--total-steps": 5,
                    "--current-step": getCurrentStep(selectedRequest),
                  } as React.CSSProperties
                }
              >
                {Array.from({ length: 5 }, (_, index) => (
                  <div key={index} className="w-full">
                    <div
                      className={`step-item ${index < getCurrentStep(selectedRequest) ? "active" : ""
                        }`}
                    >
                      <div className="step-number">{index + 1}</div>
                      {index < 4 && <div className="step-line"></div>}
                    </div>
                    <div className="mt-2 fs-12">{steps[index]}</div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div>
              {devComments.length > 0 && (
                <>
                  <hr />
                  <div>
                    <h6 className="pb-2">Developer comments</h6>
                    {devComments.map((comment: any, idx: any) => (
                      <div key={idx} className="w-15">
                        <div className="border p-2 rounded-10">
                          <p>{comment.content}</p>
                        </div>
                        <p className="fs-10 py-2 w-max ml-auto">
                          {formatDateToTime(comment.timestamp)}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal>
        <Modal
          show={acceptedModal}
          onHide={() => setAcceptedModal(false)}
        >
          <div className="container py-3">
            <p className="fw-bold ">
              You have accepted the request for an agent
            </p>
            <p>
              You have accepted to be an agent for this property:{" "}
              <span className="text-primary capitalize">
                {selectedRequest?.propertyName}
              </span>{" "}
              <span className="fw-bold">for {selectedRequest?.clientName}</span>
              .
            </p>
            <p className="my-2">
              Has the inspection been carried out yet? Click to upload proof of
              payment
            </p>
            <div className="text-center my-4">
              {selectedRequest?.status === "Inspection Booked" ? (
                <button
                  className="bg-primary rounded-10 text-white p-2 h-max"
                  onClick={() => {
                    // setModalAction('completed')
                    setQuestionModal(true);
                  }}
                  disabled={isLoading}
                >
                  Inspection completed?
                </button>
              ) : (
                <button
                  className="bg-black rounded-10 text-white p-2 h-max"
                  onClick={() => {
                    setAcceptedModal(false);
                    setIsAgentUpload(true);
                    setShowProceedtoUploadDoc(true);
                  }}
                >
                  Proceed to upload documents
                </button>
              )}
            </div>
          </div>
        </Modal>
        <UploadReceipt
          show={showProceedtoUploadDoc}
          onClose={() => {
            setIsAgentUpload(false);
            setShowProceedtoUploadDoc(false);
          }}
          propertyId={selectedRequest?.interestID}
          item={selectedRequest}
          isAgentUpload={isAgentUpload}
          closeModal={setShowProceedtoUploadDoc}
        ></UploadReceipt>
        <Modal
          show={questionModal}
          onClose={() => setQuestionModal(false)}
          dismissible={false}
        // size="sm"
        >
          <div className="p-4">
            <div className="flex justify-between gap-2">
              <h5 className="w-full no-text-wrap">
                Has Inspection been completed?
              </h5>
              <button
                onClick={() => setQuestionModal(false)}
                className="bg-white"
              >
                <i className="fa-regular fa-x"></i>
              </button>
            </div>
            <div className="flex gap-2 my-4">
              <button
                onClick={handleInspectionCompleted}
                className="bg-primary rounded-10 p-2 w-full text-white"
              >
                Yes
              </button>
              <button
                onClick={() => setQuestionModal(false)}
                className="border-red text-red bg-white rounded-10 p-2 w-full"
              >
                No
              </button>
            </div>
          </div>
        </Modal>
      </div>

      {/* <Modal show={showModal} onClose={() => setShowModal(false)}>
        {request.id && <RequestViewCard req={request} accept={() => {}} />}
      </Modal> */}
    </div>
  );
};
